import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const bigCtaBlockFn = /* @__PURE__ */ createRecipe('big-cta-block', {}, [])

const bigCtaBlockVariantMap = {}

const bigCtaBlockVariantKeys = Object.keys(bigCtaBlockVariantMap)

export const bigCtaBlock = /* @__PURE__ */ Object.assign(memo(bigCtaBlockFn.recipeFn), {
  __recipe__: true,
  __name__: 'bigCtaBlock',
  __getCompoundVariantCss__: bigCtaBlockFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: bigCtaBlockVariantKeys,
  variantMap: bigCtaBlockVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, bigCtaBlockVariantKeys)
  },
  getVariantProps: bigCtaBlockFn.getVariantProps,
})